import PropTypes from 'prop-types';
import { Text } from '@bevy/bevy-design-system';

export default function TextDisplay({ label, value }) {
  return (
    <div>
      <Text variant='helper'>{label}</Text>
      <Text color='black'>{value}</Text>
    </div>
  );
}

TextDisplay.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
};
